import { Link } from 'react-router-dom'
import Trashcan from '../assets/trashcan.svg'
import { projectFirestore } from "../firebase/config"
// import { useState } from 'react'

//components
import Stars from './Stars'
//import TagList from './TagList'

// styles
import './RecipeList.css'
//import star from '../assets/star.svg'
//import {FaStar} from "react-icons/fa"

export default function RecipeList({ recipes, sw }) {
  //const [tgs, setTgs] = useState([])
  //const [tg, setTg] = useState('')
  // console.log('sw:',sw)

  if (recipes.length === 0) {
    return <div className="error">No jokes to load...</div>
  }

  const handleClick = (id) => {
    projectFirestore.collection('recipes').doc(id).delete()
  }

  // const tgsSet = (tg) => {
  //   if (tg && !tgs.includes(tg)) {
  //     tgs.push(tg)
  //   }
  // }

  return (
    <div>
      {/* <TagList recipes={recipes} /> */}
      {/* < p > TagsX: {tgs.map(i => <span key={i}>{i} </span>)}</p > */}
      <div className="recipe-list">
        {recipes.map(recipe => (
          <div key={recipe.id} className="card">
            <h3>{recipe.title} - {recipe.author} - { }
              {recipe.stars}
              <Stars no={recipe.stars} />
              ({recipe.reviews})</h3>

            <div>{recipe.body.substring(0, 135)}...</div>
            {/* <span>Tagsx: </span> */}
            {/* {recipe.tags.map(ing => (
              <span key={ing}>
                <span>{ing} </span>
                {tgsSet(ing)}
              </span>
            ))}  */}
            <Link to={`/recipes/${recipe.id}`}>Rate It</Link>
            {/* Delete a transaction, remove on web */}
             { sw && <img
              className="delete"
              onClick={() => handleClick(recipe.id)}
              src={Trashcan} alt="delete icon"
            /> }
          </div>
        ))}
      </div>
    </div >
  )
}
